<template>
  <b-modal id="create-chat" centered hide-footer hide-header @hidden="reset">
    <h3>Create Chat</h3>

    <div v-if="added.length" class="mb-3">
      <h5 class="mb-2">Chat members:</h5>
      <b-list-group>
        <b-list-group-item
          v-for="contact in added"
          :key="contact.id"
          class="d-flex justify-content-between align-items-center"
        >
          {{ contact.name }}
          {{ contact.nickname ? `(${contact.nickname})` : "" }}
          <b-btn class="p-0" variant="link" @click="removeContact(contact)">
            <i class="icon-trash text-danger" />
          </b-btn>
        </b-list-group-item>
      </b-list-group>
    </div>

    <div class="mb-3">
      Select the contacts you want to add to the chat.
    </div>

    <b-table
      :fields="[
        { key: 'name', label: 'Username' },
        { key: 'nickname', label: 'Nickname' },
        { key: 'email', label: 'Email' },
        { key: 'actions', label: '', class: 'text-center' }
      ]"
      :items="contacts"
      show-empty
    >
      <template #empty>
        <div class="my-3 text-center font-lg">
          You have no accepted contacts
        </div>
      </template>

      <template #cell(actions)="{ item }">
        <b-btn
          :disabled="isAdded(item)"
          class="p-0"
          variant="link"
          @click="addContact(item)"
        >
          <i v-if="isAdded(item)" class="icon-check text-success" />
          <i v-else class="icon-plus text-primary" />
        </b-btn>
      </template>
    </b-table>

    <div class="mt-3 text-center">
      <b-btn
        :disabled="!added.length"
        class="px-4"
        variant="primary"
        @click="createChat"
      >
        Create Chat
        <template v-if="added.length">
          with {{ added.length | pluralize("member") }}
        </template>
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    added: []
  }),

  computed: {
    ...mapGetters("contacts", { contacts: "acceptedContacts" }),

    addedIds() {
      return this.added.map(c => c.id);
    }
  },

  methods: {
    addContact(contact) {
      this.added.push(contact);
    },

    createChat() {
      this.$emit("create", this.addedIds);
      this.$bvModal.hide("create-chat");
    },

    isAdded(contact) {
      return !!this.added.find(c => c.id == contact.id);
    },

    removeContact(contact) {
      this.added = this.added.filter(c => c.id !== contact.id);
    },

    reset() {
      this.added = [];
    }
  }
};
</script>
